import PaymentTransaction from 'app/src/data/models/PaymentTransaction';
import RetailCollection from 'app/src/data/models/RetailCollection';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class PaymentTransactionCollection extends RetailCollection {
  get model() {
    return PaymentTransaction;
  }

  /**
   * Return the REST url for collection of payment service PaymentTransactions
   * @returns {string} the url representing the REST endpoint
   */
  url() {
    return URLHelper.getAccountURL('/PaymentTransaction.json');
  }

  /**
   * Overridden to parse out superfluous json that the current LSCloud returns us
   * @param response
   * @returns {*}
   */
  parse(response) {
    // response.PaymentTransaction is an array of the PaymentTransaction structures we want.
    // Return it directly if an object is found; otherwise return an empty array and let
    // Backbone handle it
    return response.PaymentTransaction || [];
  }
}
